import {Component} from "react";
import "./TrackingReviewStyles.css"
import SectionTitle from "../SectionTitle"
import DisplayScreens from "../DisplayScreens";
import InfoList from "../InfoList";
import React from 'react';
import Fade from 'react-reveal/Fade'
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";

class TrackingReview extends Component {
    constructor() {
        super();
        this.state = {
            images: ["./trackingReview/CN_POS_1 (2).svg", "./trackingReview/CN_POS_1 (1).png", "./trackingReview/CN_POS_2 (1).svg", "./trackingReview/CN_POS_2 (1).png", "./trackingReview/push.svg", "./trackingReview/push.png"],
            isRetina: window.devicePixelRatio >= 2 ? true : false
        }
    }

    render() {
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div id="box-2" className={"tracking-review"}>
                <FancyNavigation/>
                <SectionTitle title={"Отслеживайте ход рассмотрения пособия"}/>
                <Fade left duration={5000}>
                    <div className={"tracking-review-blueline"}></div>
                </Fade>
                <div className={"tracking-review-container"}>
                    <div className={"tracking-review-screenshots"}>
                        <div className={"tracking-review-display-screen1"}>
                            <Fade delay={1500}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"tracking-review-display-screen2"}>
                            <Fade delay={700}>
                                <DisplayScreens screen={screen2}
                                                message={screen3}/>
                            </Fade>
                        </div>
                    </div>
                    <div className={"tracking-review-infolist"}>
                        <InfoList
                            list={["Информация о пособиях", "Push-уведомления о выплате больничных", "Отслеживание статусов пособий"]}
                            side={"right"}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default TrackingReview;